module.exports = __webpack_public_path__ + "img/logotel_pot_d.d7bb203b.png";